<template>
    <el-container class="body-container" style="position: relative;padding-bottom: 10px;background: linear-gradient(to bottom, #aaaeb1, #eeeeee);">
        <el-aside width="200px" style="overflow: hidden;margin-bottom: 160px;background-color: #fff;">
            <div class="menu-title">审批中心</div>
            <menu-tree @handleSelect="changeSearch"></menu-tree>
        </el-aside>
        <el-container style="margin-bottom: 160px;height: auto;">
            <el-header class="message-header" style="height: auto;">
                {{ title }}
            </el-header>
            <el-main class="message-content">
                <div>
                    <div class="message-operation">
                        <el-form :model="form" label-width="60px" size="mini" class="table-form">
                            <el-row :gutter="20">
                                <el-col :span="6">
                                    <el-form-item label="关键字">
                                        <el-input v-model="searchtForm.keyWord"  @keyup.enter.native="searchOption"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="标题">
                                        <el-input v-model="searchtForm.msgTitle" @keyup.enter.native="searchOption"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="接收时间">
                                        <div style="display: flex;">
                                            <el-date-picker
                                                v-model="searchtForm.startDay"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                            >
                                            </el-date-picker>
                                            <span style="margin: 0 10px;">-</span>
                                            <el-date-picker
                                                v-model="searchtForm.endDay"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                :picker-options="{
                                                    disabledDate (time) {
                                                        return time.getTime() < new Date(new Date(searchtForm.startDay).setHours(0, 0, 0, 0))
                                                    }
                                                }"
                                            >
                                            </el-date-picker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div style="margin-left: 10px;">
                            <el-button type="primary" style="font-size: 12px;" align="center" size="mini" @click="searchOption">查询</el-button>
                            <el-button align="center" style="font-size: 12px;" size="mini" @click="searchReset">刷新</el-button>
                        </div>
                    </div>
                </div>
                <ul style="overflow: auto;padding-left: 0;margin-top: 0;">
                    <li v-for="(item,index) in messageList" :key="index" class="message-list">
                        <el-avatar v-if="item.applyUserPic"  :size="30" style="width: 32px;" :src="global.BASE_URL + item.applyUserPic"></el-avatar>
                        <el-avatar v-else :size="30" :style="{'background-color':getUserColor(item).backgroundColor,'width':'32px'}"> {{ item.applyUserName?item.applyUserName.substr(0,1):'' }} </el-avatar>
                        <div class="message-list_right">
                            <div>
                                <span class="list_right--name" v-if="curIdx == 1 || curIdx == 5 || curIdx == 6">
                                    <span>{{ item.applyUserName }}</span>申请的<span class="red-text">{{item.flowStr1}}</span>({{item.typeName}})需要你审批。
                                </span>
                                <span class="list_right--name" v-else-if="curIdx == 2 || curIdx == 7 || curIdx == 8">
                                    <span>{{item.applyUserName}}</span>申请的<span class="red-text">{{item.flowStr1}}</span>已由您审批完成。
                                </span>
                                <span class="list_right--name" v-else-if="curIdx == 3">
                                    <span>{{item.senderName}}</span>抄送的<span class="red-text">{{item.flowStr1}}</span>需要你查阅。
                                </span>
                                <span class="list_right--name" v-else-if="curIdx == 4 ">
                                    <span>{{item.senderName}}</span>抄送的<span class="red-text">{{item.flowStr1}}</span>已由您查阅完成。
                                </span>
                                <span class="list_right--detail" @click="goDetail(item)"> 查看详情 </span>
                            </div>
                            <div class="list_right--time">{{ item.applyTime?dateFormat(item.applyTime):dateFormat(item.auditTime) }}</div>
                        </div>
                    </li>
                </ul>
                <el-dialog :visible.sync="detailVisible" title="消息详情">
                    <p>标题：{{ detailData.msgTitle }}</p>
                    <p>发送人：{{ detailData.senderName }}</p>
                    <p>发送时间：{{ detailData.createTime }}</p>
                    <p>消息内容：{{ detailData.msgBody }}</p>
                </el-dialog>
                <el-footer style="display: flex;justify-content: end;height: auto;">
                    <table-page
                        ref="messageListPage"
                        :url="messageListUrl"
                        :form="form"
                        :flag="true"
                        @page-change="convert"
                    ></table-page>
                </el-footer>
            </el-main>
        </el-container>
        <div class="footCss"></div>
    </el-container>
</template>

<script>
import MenuTree from './components/menuTree.vue'
import TablePage from "@/components/TablePage";
import { getUserColor } from '@/assets/common/common.js'
import { encryptDes } from "@/utils/des";
import Cookies from 'js-cookie';
import moment from 'moment';
import { redirectEncrypt } from '../../assets/common/redirectEncrypt.js';
export default {
    components:{
        MenuTree,
        TablePage,
    },
    data(){
        return {
            getUserColor,
            curIdx: 0,
            tabData: [
                {
                    tabId: '20',
                    tabName: '未读'
                },
                {
                    tabId: '50',
                    tabName: '已读'
                }
            ],
            type: 'general',
            filterPopover: false,
            form: {},
            messageListUrl: this.global.BASE_URL_2971 + "/msi/base/info/message/findMessages",//this.global.BASE_URL_2971 + "/msi/cms/web/article/findWebArticle",
            messageList: [
                {
                    name: '员工1',
                    message: '刘澳门 (iuaomen@qq.com)、合同-(hetongyi@qq.com)等41人的劳动合同续签申请流程自动发起失败，请根据需要手动发起',
                    downFlag: false
                },
                {
                    name: '员工2',
                    message: '您好，您的订阅内容【发薪审批】已经为您准备好了',
                    downFlag: true
                },
                {
                    name: '员工3',
                    message: '你好，你提交的离职交接申请已审批完成，审批结果:通过',
                    downFlag: true,
                }
            ],
            searchtForm:{},
            detailVisible: false,
            detailData: {},
            title:'',
        }
    },
    mounted() {
        document.addEventListener('visibilitychange', this.handleVisibility)
        // 初始化时主动执行一次
        this.handleVisibility()
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this.handleVisibility)
    },
    created(){
        this.initDefaultActive()
        // this.handleVisibility()
    },
    methods:{
        initDefaultActive() {
            const route = this.$route || {}
            const routeDefaultActive =
                (route.query && route.query.defaultActive) ||
                (route.params && route.params.defaultActive)

            this.curIdx = routeDefaultActive ? Number(routeDefaultActive) : 0
        },
        handleVisibility() {
            if (document.visibilityState === 'visible') {
                if(this.curIdx !== 0){
                    this.changeSearch(this.curIdx,true) 
                }else{
                    this.changeSearch(1,true) 
                }
            }
        },
        async getFlowUrlSeting(flowCode){
            const searchParams = window.location.search.substring(1).split('&');
            const params = {};
            for (const param of searchParams) {
            const [key, value] = param.split('=');
            params[key] = value;
            }
            let formData = {
            data:{
                flowCode:flowCode,
            }
            }
            let res =  await this.$axios.post(`${this.global.BASE_URL}/msi/flow/design/flow/findFlowConf`,formData,{
                headers: {
                'certificate':params.auth // 使用 Authorization 头部传递 token
                }
            })
            if(res.data.data){
            let resData = res.data.data
            if(resData.pcPageUrl){
                return resData.pcPageUrl
            }else{
                return ''
            }
            }
            return ''
        },
        async goDetail(item){
            let pageUrl = await this.getFlowUrlSeting(item.flowCode)
            let name = pageUrl.split('/')[pageUrl.split('/').length - 1]
            item.applyTime = moment(item.applyTime).format("yyyy-MM-DD HH:mm:ss");
            item.createTime = moment(item.applyTime).format("yyyy-MM-DD HH:mm:ss");
            console.log(item.applyTime,'appky')
            let todo = encryptDes(JSON.stringify(item))
            let systemId = 0
            let systemCode = ''
            if(['拜访管理','销售管理系统','流向管理','营销线考勤'].includes(item.typeName)){
                systemId = 103
                systemCode = 'saleSystem'
            }else{
                systemId = 1
                systemCode = 'oaSystem'
            }
            if(this.curIdx == 1 || this.curIdx == 5 || this.curIdx == 6){
                if(pageUrl == ''){
                    // window.open('http://localhost:3000/#/MyApprovalPend?toDo='+todo,'_blank');
                    let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/MyApprovalPend?toDo='+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                    window.open(url,'_blank');
                }else{
                    let url = await redirectEncrypt(this.global.BASE_URL_2971+`/#/${name}Pend?toDo=`+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                    window.open(url,'_blank');
                }
            }else if(this.curIdx == 2 || this.curIdx == 7 || this.curIdx == 8){
                if(pageUrl == ''){
                    // window.open('http://localhost:3000/#/MyApprovalView?toDo='+todo,'_blank');
                    let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/MyApprovalView?toDo='+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                    window.open(url,'_blank');
                }else{
                    let url = await redirectEncrypt(this.global.BASE_URL_2971+`/#/${name}View?toDo=`+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                    window.open(url,'_blank');
                }
            }else{
                if(pageUrl == ''){
                    // window.open('http://localhost:3000/#/myCopyView?toDo='+todo,'_blank');
                    let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/myCopyView?toDo='+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                    window.open(url,'_blank');
                }else{
                    let url = await redirectEncrypt(this.global.BASE_URL_2971+`/#/${name}View?toDo=`+todo+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                    window.open(url,'_blank');
                }
            }
        },
        dateFormat(date) {
            if (date) {
                return moment(date).format("YYYY-MM-DD HH:mm");
            }
            return "";
        },
        changeSearch (index,noRefresh = false) {
            this.curIdx = index
            console.log(index,'index')
            if(!noRefresh){
                 this.form = {}
                 this.searchtForm = {}
            }
            if(index == 1){
                this.title = '待处理'
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/myTasks"
            }else if(index == 2){
                this.title = '已处理'
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/myCompletedTasks"
            }else if(index == 3){
                this.title = '待阅'
                this.searchtForm = {
                    messageStatus: '20',
                }
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/findFlowMsg"
            }else if(index == 4){
                this.title = '已阅'
                this.searchtForm = {
                    messageStatus: '50',
                }
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/findFlowMsg"
            }else if(index == 5){
                this.title = '协同办公'
                this.searchtForm = {
                    isSale: 'N',
                }
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/myTasks"
            }else if(index == 6){
                this.title = '销售管理'
                this.searchtForm = {
                    isSale: 'Y',
                }
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/myTasks"
            }else if(index == 7){
                this.title = '协同办公'
                this.searchtForm = {
                    isSale: 'N',
                }
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/myCompletedTasks"
            }else if(index == 8){
                this.title = '销售管理'
                this.searchtForm = {
                    isSale: 'Y',
                }
                this.messageListUrl = this.global.BASE_URL_2971 + "/msi/flow/engine/process/myCompletedTasks"
            }
            this.search('refresh')
        },
        handleType(type){
            this.type = type
            this.search()
        },
        searchReset() {
            this.searchtForm = {}
            if(this.curIdx == 3){
                this.searchtForm = {
                    messageStatus: '20'
                }
            }else if(this.curIdx == 4){
                this.searchtForm = {
                    messageStatus: '50'
                }
            }
            this.filterPopover = false
            this.search()
        },
        searchOption() {
            this.filterPopover = false
            this.search()
        },
        search(params) {
            console.log(this.messageListUrl,'mess',this.searchtForm)
            this.form= {...this.searchtForm}
            if(this.curIdx == 1){
                this.form.params = {
                    ...this.searchtForm,
                    createTime: this.searchtForm.startDay?[this.searchtForm.startDay,this.searchtForm.endDay]:null,
                    applyUserName: this.searchtForm.senderName,
                } 
            }else if(this.curIdx == 2){
                this.form.params = {
                    ...this.searchtForm,
                    applyTime: this.searchtForm.startDay?[this.searchtForm.startDay,this.searchtForm.endDay]:null,
                    applyUserName: this.searchtForm.senderName,
                } 
            }else{
                this.form= {
                    ...this.searchtForm,
                    sendStartDate: this.searchtForm.startDay,
                    sendEndDate: this.searchtForm.endDay
                }
            }
            this.$nextTick(()=>{
                this.$refs["messageListPage"].getTableData(params);
            })
        },
        convert(tableData) {
            this.messageList = tableData.data;
        },
        showDetail(item) {
            //未读的消息点击查看后，调用接口将消息状态改为已读
            if(item.status == '20'){
                let fromData = new FormData()
                fromData.append('msgCode', item.msgCode)
                
                this.$axios.post(this.global.BASE_URL_2971 + "/msi/base/info/message/readMessage", fromData).then(res => {
                    console.log(res)
                })
            }
            this.detailData = item;
            this.detailVisible = true;
            this.search()
        },

        deletMessage(item) {
            let fromData = new FormData()
            fromData.append('msgCode', item.msgCode)
            
            this.$axios.post(this.global.BASE_URL_2971 + "/msi/base/info/message/deleteMessage", fromData).then(res => {
                console.log(res)
            })
        },
        returnColor(){
            let colorList = ['#0cc0c9', '#ffab24', '#2e9cff', '#ff6952']
            let randomIndex = Math.floor(Math.random() * colorList.length)
            console.log(colorList[randomIndex],'colorList[randomIndex]')
            return colorList[randomIndex]
        },
    }
}
</script>

<style lang="less" scoped>
.menu-title {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    padding: 20px 28px 0 30px;
    color: #bb0009;
}
.message-header {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: #33383D;
    margin: 16px 16px 0;
    padding: 0 16px;
}
.message-content {
    margin: 16px 16px 0;
    background-color: #fff;
    border-radius: 8px;

    .clearfix {
        content: "";
        display: table;
        clear: both;
    }
    .tab-wrap {
        display: flex;
    }
    .tab-list {
        width: 100%;
        margin-bottom: 16px;
        list-style: none;
        padding-left: 0px;
        margin: 0 0 16px 0;
    }
    .tab-item:first-child {
        margin-left: 0px;
    }
    .tab-item {
        float: left;
        height: 30px;
        line-height: 30px;
        margin-left: 40px;
        cursor: pointer;
        font-size: 14px;
    }
    .tab-item {
        color: #3d3533;
    }
    .tab-item.cur {
        color: #bb0009;
        border-bottom: 3px solid #bb0009;
    }

    .el-button {
        padding: 4px 7px;
    }
    .el-button:hover {
        color: #3d3533;
        background: rgba(255,157,138,.2);
        border-color: rgba(255,157,138,.2);
    }
    .selectType {
        color: #fff;
        background: #bb0009;
        border-color: #bb0009;
    }
    .selectType:hover {
        color: #fff !important;
        background: #bb0009 !important;
        border-color: #bb0009 !important;
    }
    .message-operation {
        display: flex;
        justify-content: start;
        border: none;
        padding-bottom: 3px;
        border-bottom: 1px dashed #EBEEF5;

        .el-button {
            height: 26px;
        }
    }

    .message-list {
        color: #606266;
        font-size: 12px;
        line-height: 1.5;
        display: flex;
        padding-bottom: 12px;
        padding-top: 12px;
        margin: 0 0;
        border-bottom: 1px solid #ebeef5;;

        .message-list_right {
            padding-left: 20px;
            width: 100%;
            color: #606266;
            font-size: 14px;

            .list_right--name {
                margin-right: 5px;

                span {
                    color: #bb0009;
                }

                .red-text {
                    color: #14100f;
                    font-weight: 700;
                    margin: 0 8px;
                }
            }

            .list_right--time {
                // font-size: 10px;
                // color: #a9b8bf;
                display: block;
                color: #aaa;
                margin-top: 3px;
                font-size: 12px;
                line-height: 14px;
                font-family: "PingFang SC","Hiragino Sans GB",STHeitiSC,Helvetica,"Helvetica Neue","Microsoft YaHei",Tahoma;
            }

            .list_right--detail {
                color: #bb0009;
                margin-left: 5px;
            }
            .list_right--detail:hover {
                cursor: pointer;
            }
        }
    }

    .message-list:hover {
        background-color: rgba(255,157,138,.1);
    }
}
.footCss {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 146px;
  box-sizing: border-box;
  background: url(../../assets/images/red-footer-background.png) no-repeat;
  background-size: 100% 100%;
}
::v-deep .el-avatar>img {
    width: 32px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/flow-center/index.vue